export default __webpack_public_path__ + "static/media/back.e752a044.jpg";